import { APIClient } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { PostSensor } from '@frontend/device/types';

export class DeviceSensorClient extends APIClient {
    public static readonly endpoint = '/device-api/v1';

    public static async postDeviceSensor(accountId: string, iotId: string, deviceId: string, body: PostSensor, includeAccessToken?: boolean, withCredentials?: Token | undefined): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/devices/${deviceId}/sensors`, body, includeAccessToken, withCredentials);
        return await this.handleVoidResponse(response);
    }
}
